import { Box, Typography } from "@mui/material";
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { ChartColors } from "views/dashboard/components/Charts";
import { DashTooltipClickable } from "views/dashboard/components/DashTooltipClickable";

export interface IDashDoughnutTaxProps {
    tax: number | null;
    insideText?: string;
    subtitle?: string | string[] | React.ReactNode | React.ReactNode[];
    tooltip?: string;
    width?: number;
    onDataClick?: (filledDataClick: boolean) => void;
}

export const DashDoughnutTax: React.FC<IDashDoughnutTaxProps> = (props) => {

    const { tax, subtitle, tooltip, insideText, width = 180, onDataClick } = props;
    const subtitleArr = subtitle == null ? null : Array.isArray(subtitle) ? subtitle : [subtitle];

    return (
        <Box textAlign="center" width={width}>
            <div style={{ position: "relative", height: 180, width: "100%" }}>
                <Doughnut
                    data={
                        {
                            datasets: [
                                {
                                    data: [tax, tax == null ? 100 : 100.0 - tax],
                                    backgroundColor: [ChartColors.TaxOn, ChartColors.TaxOff]
                                },

                            ]
                        }
                    }
                    options={
                        {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {
                                    position: "bottom",
                                    onClick: () => { }
                                },
                                tooltip: {
                                    enabled: false
                                },
                                datalabels: {
                                    display: false,
                                },
                                insideText: {
                                    text: !!insideText ? insideText : tax == null ? "N/A" : tax.toFixed(0) + "%",
                                    fontSize: insideText ? 1.5 : 2,
                                    color: "#434343"
                                }
                            },
                            onClick: (evt, el) => {
                                if (el.length > 0) {
                                    if (el[0].index == 1 && onDataClick) onDataClick(false);
                                    else if (el[0].index == 0 && onDataClick) onDataClick(true);
                                }
                            }
                        }
                    }
                />
            </div>
            {
                subtitleArr?.map((item, index) => (
                    <div key={index}>
                        <Typography key={index} component="div" variant="overline">
                            <span>{item} {index == subtitleArr.length - 1 && tooltip ? <DashTooltipClickable tooltip={tooltip} /> : undefined}</span>
                        </Typography>
                    </div>
                ))
            }
        </Box>
    );
};